import api from '../../../../helpers/api';

const cache = {};

export const getRealtyOffersSecondary = (payload) => {
  return api.post(
    `/developer/bloomberg/secondary-market/secondary-market`,
    payload
  );
};

export const getBigNumbersOffersSecondary = (payload) => {
  return api.post(
    `/developer/bloomberg/mvp-secondary-market/secondary-market`,
    payload
  );
};

export const getPinsOffersSecondary = (payload) => {
  return api.post(`/developer/bloomberg/secondary-market/pins`, payload);
};

export const getRealtiesByPeriodOffersSecondary = (payload) => {
  return api.post(
    `developer/bloomberg/secondary-market/realty-anounced-by-period`,
    payload
  );
};

export const getAveragePricePerSquareMeterOffersSecondary = (payload) => {
  return api.post(
    `developer/bloomberg/secondary-market/average-price-per-square-meter`,
    payload
  );
};

export const getAdsPerExistingRealtiesOffersSecondary = (payload) => {
  return api.post(
    `developer/bloomberg/secondary-market/ads-per-existing-realties`,
    payload
  );
};

export const getInfoWindowData = (payload) => {
  return api.post(`developer/bloomberg/secondary-market/info-window`, payload);
};

export const getModalInfoOffersSecondary = (payload) => {
  return api.post(
    '/developer/bloomberg/mvp-secondary-market/pin-info',
    payload
  );
};

export const getSecondaryList = () => {
  return api.get('/developer/bloomberg/secondary-market/list');
};

export const getAvaliableFilters = (cityId) => {
  if (cache?.[`availableYears-${cityId}`]) {
    return cache?.[`availableYears-${cityId}`];
  }
  const data = api.get(
    `developer/bloomberg/mvp-secondary-market/list/filters/${cityId}`
  );
  cache[`availableYears-${cityId}`] = data;
  return data;
};
